// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Draggable } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var keys = ['n', 'e', 's', 'w', 'se', 'sw', 'ne', 'nw'];
/**
 * @hidden
 */
var ResizeHandlersVue2 = {
  name: 'ResizeHandlers',
  // @ts-ignore
  emits: {
    'resize': null
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  methods: {
    onDrag: function onDrag(event, key) {
      event.originalEvent.preventDefault();
      this.$emit('resize', event, {
        end: false,
        direction: key
      });
    },
    onRelease: function onRelease(event, key) {
      event.originalEvent.preventDefault();
      this.$emit('resize', event, {
        end: true,
        direction: key
      });
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h("div", [keys.map(function (key, index) {
      var _this = this;
      return (
        // @ts-ignore  function children
        h(Draggable, {
          key: index,
          onDrag: function onDrag(e) {
            return _this.onDrag(e, key);
          },
          on: this.v3 ? undefined : {
            "drag": function onDrag(e) {
              return _this.onDrag(e, key);
            },
            "release": function release(e) {
              return _this.onRelease(e, key);
            }
          },
          onRelease: function release(e) {
            return _this.onRelease(e, key);
          }
        }, this.v3 ? function () {
          return [h("div", {
            "class": 'k-resize-handle k-resize-' + key,
            style: {
              display: 'block',
              touchAction: 'none'
            }
          })];
        } : [h("div", {
          "class": 'k-resize-handle k-resize-' + key,
          style: {
            display: 'block',
            touchAction: 'none'
          }
        })])
      );
    }, this)]);
  }
};
/**
 * @hidden
 */
var ResizeHandlers = ResizeHandlersVue2;
export { ResizeHandlers, ResizeHandlersVue2 };